import React from "react";
import "./EmptyChartState.css";
import { Button } from "primereact/button";
import CommonLoaderBlue from "../../../../../../../components/Loader/LoaderBlue";
import { useNavigate } from "react-router-dom";
export default function EmptyChartState({ isLoading, frominner }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        border: frominner ? "none" : "solid  #E1E4F3 1px",
        height: frominner ? "33rem" : "26.7rem",
        background: frominner ? "transparent" : "#EFF2F8",
      }}
      className="main-empty-container"
    >
      {isLoading ? (
        <CommonLoaderBlue sizehere={20} color="royalblue" />
      ) : (
        <>
          <p>
            No data available yet.{" "}
            {!frominner
              ? "Start enrolling to see your performance metrics!"
              : ""}
          </p>
          {!frominner && (
            <Button
              onClick={() => navigate("/prepaid-newenrollment")}
              label="Start Enrollment"
              className="nextbtn"
            />
          )}
        </>
      )}
    </div>
  );
}
